module.exports = __webpack_public_path__ + "static/media/ten-candles.a94da5da.jpg";